import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { AuthModule } from '~/auth/auth.module';
import { ComponentModule } from '~/component/component.module';
import { CoreModule } from '~/core/core.module';
import { OrganizerSharedModule } from '~/organizer/shared/shared.module';
import { ParamethorModule } from '~/paramethor/paramethor.module';

import { OrganizerTimeslotPageManageComponent } from './components/pages/manage/manage.component';
import { OrganizerTimeslotPageParticipantListComponent } from './components/pages/participant/list/list.component';
import {
  OrganizerTimeslotPageParticipantManageComponent
} from './components/pages/participant/manage/manage.component';
import {
  OrganizerTimeslotPagePreScheduleGroupSizeComponent
} from './components/pages/pre-schedule/group-size/group-size.component';
import {
  OrganizerTimeslotPagePreScheduleLiveUrlComponent
} from './components/pages/pre-schedule/live-url/live-url.component';
import { OrganizerTimeslotPagePreSchedulePlansComponent } from './components/pages/pre-schedule/plans/plans.component';
import { OrganizerTimeslotPagePreScheduleComponent } from './components/pages/pre-schedule/pre-schedule.component';
import { OrganizerTimeslotPageScheduleComponent } from './components/pages/schedule/schedule.component';
import { OrganizerTimeslotRoutingModule } from './timeslot-routing.module';

/**
 * Organizer Activity management
 */
@NgModule({
  declarations: [
    OrganizerTimeslotPageManageComponent,
    OrganizerTimeslotPageParticipantListComponent,
    OrganizerTimeslotPageParticipantManageComponent,
    OrganizerTimeslotPagePreScheduleComponent,
    OrganizerTimeslotPagePreScheduleGroupSizeComponent,
    OrganizerTimeslotPagePreSchedulePlansComponent,
    OrganizerTimeslotPagePreScheduleLiveUrlComponent,
    OrganizerTimeslotPageScheduleComponent,
  ],
  imports: [
    ReactiveFormsModule,
    FormsModule,
    AuthModule,
    CommonModule,
    CoreModule,
    OrganizerTimeslotRoutingModule,
    ComponentModule,
    ParamethorModule,
    OrganizerSharedModule,
  ],
})
export class OrganizerTimeslotModule {}
